import styled from 'styled-components'

export const ReportsModalContainer = styled.div`
  width: 528px;
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const FiltersContainer = styled.div`
  overflow-y: auto;
  height: calc(100vh - 184px);
  cursor: default;
`

export const ReportsModalHeader = styled.div`
  width: 532px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.1);
  background-color: #FFFFFF;
`

export const ReportsModalTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
`

export const ReportsModalToggleWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  cursor: pointer;
`

export const ReportsModalSubTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 32px 0 32px 0;
`

export const ReportsModalSubTitle = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
  border-bottom: 1px dotted rgba(32, 32, 32, 0.2);
`

export const ReportsModalFooter = styled.div`
  width: 532px;
  height: 112px;
  background-color: rgba(32, 32, 32, 0.03);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px;
`

export const ReportsModalFooterText = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.5);
  display: flex;
  gap: 8px;
`

export const ReportsModalFooterBtnWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const FilterHeaderWrapper = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  user-select: none;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(p) => {
    return p.isActive ? '8px 8px 0 0' : '8px'
  }};
  padding: 0 8px 0 24px;
  border: 1px solid;
  border-bottom: ${(p) => {
    return p.isActive ? 'none' : '1px solid'
  }};
  border-color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.2)'
  }};
  cursor: pointer;
  box-shadow: ${(p) => {
    return p.isActive ? 'none' : '0 1px 2px rgba(32, 32, 32, 0.05)'
  }};

  :hover {
    div {
      color: rgba(10, 161, 244, 1);

      path {
        fill: rgba(10, 161, 244, 1);
        fill-opacity: 1;
      }
    }    

    box-shadow: ${(p) => {
    return p.isActive ? 'none' : '0 2px 8px rgba(32, 32, 32, 0.1'
  }});
  }
`

export const FilterHeaderTitleWrapper = styled.span`
  display: flex;
  gap: 8px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 1)'
  }};
`

export const FilterHeaderCounter = styled.span`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  background-color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 0.1)' : 'rgba(32, 32, 32, 0.05)'
  }};
`

export const FilterHeaderToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const FiltersContentContainer = styled.div`
  width: 100%;
  padding: 32px 24px;
  background-color: rgba(32, 32, 32, 0.03);
  border: 1px solid rgba(10, 161, 244, 1);
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 8px rgba(32, 32, 32, 0.1);
  border-top: none;
  margin-bottom: ${(p) => {
    return p.lastItem ? '350px' : '0'
  }};


`


